import axios from 'axios';
import React from 'react'
import TodoList from './TodoList';
import Form from './Form';
import { nanoid } from 'nanoid';



 let todos = [
    { id: nanoid(5), name: 'laundry', completed: false },
    { id: nanoid(5), name: 'dishes', completed: false },
    { id: nanoid(5), name: 'groceries', completed: false },
  ]


export default class App extends React.Component {
  constructor(){
    super();
    this.state={
      todos: todos,
      pending: "",
      hideComplete: false
    }
  }

  submitTodo = (evt) => {
    evt.preventDefault();
    this.setState({...this.state, pending:"" ,todos: [...this.state.todos, {id: nanoid(5), name: this.state.pending, completed: false}]})
  }

  hideCompleted=()=>{
    {this.state.hideComplete ? this.setState({hideComplete: false}) : this.setState({hideComplete: true})}
  }

  setPending =(event)=>{
    this.setState({pending: event.target.value})

  }

  todoCheck = (id, status) => {
    let target = this.state.todos.findIndex(todo=>todo.id === id)
    this.state.todos[target] = {...this.state.todos[target], completed: !this.state.todos[target].completed}
    this.setState({...this.state, todos: this.state.todos})
  }

  // getTodos = ()=>{
  //   axios.get(URL)
  //   .then(res=>{
  //     this.setState({...this.state, todos: res.data.data})})
  //   .catch(err=>console.log(err))
  // }

//   deleteTodo = (id)=>{
//     axios.delete(`${URL}/${id}`)
//     .then(res=>{
//       console.log(res.data)
//       this.setState({...this.state, todos: res.data.todos})
//         })
//     .catch(err=>{
//         console.log(err.response);
//     })
// }

deleteTodo = (id)=>{
  let todos = this.state.todos.filter(todo=> todo.id !==id)
  this.setState({...this.state, todos: todos})

}


  componentDidMount(){
    // this.getTodos()

  }

  render() {
    return(
      <div>
      <TodoList todos={this.state.todos} state={this.state} todoCheck={this.todoCheck} delete={this.deleteTodo}/>
      <Form state={this.state} setPending={this.setPending} submit={this.submitTodo} hide={this.hideCompleted}/>
      </div>

    )
  }
}
